import Box from '@/Atoms/Box';
import CCText from '@/Atoms/CCText';
import CCColors from '@/Utils/CCColors';
import {FontSizes, hs, vs} from '@/Utils/Dimensions';
import {useState, useEffect, useRef} from 'react';
import {RFPercentage} from 'react-native-responsive-fontsize';
import autoResignSound from '../../../../Assets/Sounds/game_resign_countdown_sound.mp3';
import useSound from 'use-sound';
import {useTimer} from 'react-timer-hook';

function formatTime(seconds) {
  if (seconds || seconds == 0) {
    //   console.log(seconds);
    const minutes = Math.floor(seconds / 60);
    const remainingSeconds = seconds % 60;
    const formattedMinutes = String(minutes).padStart(2, '0');
    const formattedSeconds = String(remainingSeconds).padStart(2, '0');
    return `${formattedMinutes}:${formattedSeconds}`;
  }
}

// function ClockComponent({
//   timer,
//   myTurn,
//   playing,
//   setFirstMovetimer,
//   firstMovetimer,
//   showFirstMoveTimer,
// }) {
//   // Setting defaults to 10 + 5

//   // console.log('clock is:',timer);
//   const normalColor = CCColors.Green;
//   const lowTimeColor = CCColors.Red;

//   const [time, setTime] = useState(timer); // State to hold the current time
//   const [timerId, setTimerId] = useState(null); // State to hold the timer ID
//   const [isSoundPlaying, setIsSoundPlaying] = useState(false);
//   // Function to update the time
//   const updateTime = () => {
//     setTime(prevTime => Math.max(prevTime - 1, 0));
//   };
//   const [playAutoResignSound, {stop: stopAutoResignSound}] = useSound(
//     autoResignSound,
//     {
//       volume: 1,
//       loop: true, // loop the sound while countdown is active
//     },
//   );
//   // Function to start the timer
//   const startTimer = () => {
//     if (timerId) {
//       clearInterval(timerId);
//       setTimerId(setInterval(updateTime, 1000));
//     } else {
//       setTimerId(setInterval(updateTime, 1000));
//     }
//   };

//   // Function to stop the timer
//   const stopTimer = () => {
//     if (timerId) {
//       clearInterval(timerId);
//       setTimerId(null);
//     }
//   };
//   useEffect(() => {
//     setFirstMovetimer(time - firstMovetimer);
//     const timeDifference = time - firstMovetimer;

//     // Start sound when difference equals 10
//     if (timeDifference === 10 && !isSoundPlaying && showFirstMoveTimer) {
//       playAutoResignSound();
//       setIsSoundPlaying(true);
//     }

//     // Stop sound when difference equals 0 or becomes less than 0
//     if ((timeDifference === 1 || !showFirstMoveTimer) && isSoundPlaying) {
//       stopAutoResignSound();
//       setIsSoundPlaying(false);
//     }
//   }, [time, showFirstMoveTimer]);

//   useEffect(() => {
//     setTime(timer);
//     if (myTurn && playing) {
//       startTimer();
//     } else {
//       stopTimer();
//     }

//     return () => {
//       stopTimer();
//     };
//   }, [myTurn, timer, playing]);

//   const backgroundColor = time < 10 ? lowTimeColor : normalColor;

//   const color = normalColor;

//   return (
//     <Box
//       style={{
//         height: '100%',
//         width: '20%',
//         marginVertical: 'auto',
//         backgroundColor,
//         alignItems: 'center',
//         borderRadius: 4,
//         justifyContent: 'center',
//       }}>
//       <CCText
//         style={{
//           color: 'white',
//           textAlign: 'center',
//           fontFamily: 'Helvetica Neue Bold',
//         }}
//         fontSize={RFPercentage(2)}>
//         {formatTime(time)}
//       </CCText>
//     </Box>
//   );
// }

// export default ClockComponent;

function ClockComponent({
  timer,
  myTurn,
  playing,
  setFirstMovetimer,
  firstMovetimer,
  showFirstMoveTimer,
}) {
  const normalColor = CCColors.Green;
  const lowTimeColor = CCColors.Red;

  const expiryTimestamp = new Date();
  expiryTimestamp.setSeconds(expiryTimestamp.getSeconds() + timer);

  const {
    seconds,
    minutes,
    hours,
    restart,
    pause,
    resume,
    isRunning,
    milliseconds,
  } = useTimer({
    expiryTimestamp,
    autoStart: false,
    onExpire: () => {},
    interval: 20,
  });

  const [isSoundPlaying, setIsSoundPlaying] = useState(false);
  const [playAutoResignSound, {stop: stopAutoResignSound}] = useSound(
    autoResignSound,
    {
      volume: 1,
      loop: true,
    },
  );
  useEffect(() => {
    if (myTurn && playing) {
      const newExpiry = new Date();
      newExpiry.setSeconds(newExpiry.getSeconds() + timer);
      restart(newExpiry, true);
    } else {
      pause();
      const newExpiry = new Date();
      newExpiry.setSeconds(newExpiry.getSeconds() + timer);
      restart(newExpiry, false); // false = do not autoStart
    }
  }, [myTurn, playing, timer]);

  useEffect(() => {
    return () => {
      // Stop all sounds (nuclear option)
      if (window.Howler) {
        window.Howler.stop();
      }
      setIsSoundPlaying(false);
    };
  }, []);

  useEffect(() => {
    const remaining = minutes * 60 + seconds;
    const timeDifference = remaining - firstMovetimer;
    setFirstMovetimer(timeDifference);
    if (timeDifference === 10 && !isSoundPlaying && showFirstMoveTimer) {
      playAutoResignSound();
      setIsSoundPlaying(true);
    }
    if ((timeDifference <= 1 || !showFirstMoveTimer) && isSoundPlaying) {
      stopAutoResignSound();
      setIsSoundPlaying(false);
    }
  }, [minutes, seconds, showFirstMoveTimer]);
  const totalSeconds = minutes * 60 + seconds;
  const showMilliseconds = totalSeconds < 10 && hours === 0;
  const mainTime = `${String(hours * 60 + minutes).padStart(2, '0')}:${String(
    seconds,
  ).padStart(2, '0')}`;
  const mainTimeMs = `${String(minutes).padStart(1, '0')}:${String(
    seconds,
  ).padStart(2, '0')}`;
  const millisecondsText = `.${String(Math.floor(milliseconds / 100))}`;
  const baseColor =
    minutes * 60 + seconds < 10 && hours === 0 ? lowTimeColor : normalColor;
  const backgroundColor = !playing
    ? CCColors.Primary.lightBrown
    : isRunning
    ? baseColor
    : `${baseColor}80`;

  return (
    <Box
      style={{
        height: '100%',
        width: '22%',
        marginVertical: 'auto',
        backgroundColor,
        alignItems: 'center',
        borderRadius: 4,
        justifyContent: 'center',
      }}>
      <CCText
        style={{
          color: !playing ? CCColors.Primary.Dark : 'white',
          textAlign: 'center',
          fontFamily: 'Helvetica Neue Bold',
        }}
        fontSize={RFPercentage(2)}>
        {mainTime}
        {showMilliseconds && (
          <CCText
            style={{
              fontSize: RFPercentage(1.6), // Smaller font size for milliseconds
              color: !playing ? CCColors.Primary.Dark : 'white',
              fontFamily: 'Helvetica Neue Bold',
            }}>
            {millisecondsText}
          </CCText>
        )}
      </CCText>
    </Box>
  );
}

export default ClockComponent;
